import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up pop_detail",
  style: {"display":"block"}
}
const _hoisted_2 = {
  class: "custom_scroll question_list",
  style: {"margin-top":"30px"}
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "radio_wrap cnt p_5" }
const _hoisted_6 = ["for"]
const _hoisted_7 = ["name", "id", "value", "onUpdate:modelValue"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "checkbox_wrap cnt p_5" }
const _hoisted_12 = ["for"]
const _hoisted_13 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "btn_wrap _default _center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "pop_up_layer find_account",
      style: {"display":"block"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pop_tit" }, [
        _createElementVNode("p", null, "신청하기")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.questionList, (question, formIdx) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(question.orderNo + ". " + question.title), 1),
            (question.caseList && question.caseList.length > 0 && question.type !== 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (question.type === 1)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.caseList, (answer) => {
                          return (_openBlock(), _createElementBlock("li", _hoisted_5, [
                            _createElementVNode("label", {
                              for: 'radio_' + question.idx + '_' + answer.idx
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                name: `radio_${question.idx}`,
                                id: 'radio_' + question.idx + '_' + answer.idx,
                                value: answer.idx,
                                "onUpdate:modelValue": ($event: any) => (($setup.state.answerData[formIdx].caseList[0]) = $event)
                              }, null, 8, _hoisted_7), [
                                [_vModelRadio, $setup.state.answerData[formIdx].caseList[0]]
                              ]),
                              _cache[4] || (_cache[4] = _createElementVNode("em", null, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: answer.title
                              }, null, 8, _hoisted_8),
                              (answer.title === '기타' && answer.idx === $setup.state.answerData[formIdx].caseList[0])
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => (($setup.state.answerData[formIdx].answer) = $event),
                                    placeholder: "내용을 입력해주세요"
                                  }, null, 8, _hoisted_9)), [
                                    [_vModelText, $setup.state.answerData[formIdx].answer]
                                  ])
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_6)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (question.type === 2)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.caseList, (answer) => {
                          return (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createElementVNode("label", {
                              for: 'chk_' + question.idx + '_' + answer.idx
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: 'chk_' + question.idx + '_' + answer.idx,
                                value: answer.idx,
                                "onUpdate:modelValue": ($event: any) => (($setup.state.answerData[formIdx].caseList) = $event)
                              }, null, 8, _hoisted_13), [
                                [_vModelCheckbox, $setup.state.answerData[formIdx].caseList]
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("em", null, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: answer.title
                              }, null, 8, _hoisted_14),
                              (answer.title === '기타' && $setup.state.answerData[formIdx].caseList.some((item) => item === answer.idx))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => (($setup.state.answerData[formIdx].answer) = $event),
                                    placeholder: "내용을 입력해주세요"
                                  }, null, 8, _hoisted_15)), [
                                    [_vModelText, $setup.state.answerData[formIdx].answer]
                                  ])
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_12)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (question.type === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => (($setup.state.answerData[formIdx].answer) = $event),
                    placeholder: "답변을 적어주세요."
                  }, null, 8, _hoisted_17), [
                    [_vModelText, $setup.state.answerData[formIdx].answer]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "submit_btn w_120",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
        }, "완료")
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}